var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "profile-input-wrapper" },
    [
      _c(
        "profile-form",
        {
          ref: "form",
          attrs: { endpoint: "birthdate" },
          on: {
            error: function ($event) {
              return _vm.$emit("done", $event)
            },
          },
        },
        [
          _c("form", { staticClass: "form" }, [
            _c("fieldset", [
              _c("legend", { staticClass: "sr-only" }, [
                _vm._v(_vm._s(_vm.inputTitle)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex-grid-1-col gutter-lg" }, [
                _c("div", { staticClass: "input" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formattedDate,
                        expression: "formattedDate",
                      },
                    ],
                    staticClass: "req",
                    class: [
                      { "no-value": !_vm.formattedDate },
                      { valid: !!_vm.formattedDate },
                    ],
                    attrs: {
                      type: "date",
                      max: _vm.maxDate,
                      id: "birthDate",
                      name: "birthDate",
                      "data-clear": "true",
                      "data-val": "true",
                      "data-val-required": _vm.getValidationForField(
                        "required",
                        "birthDate"
                      ),
                      "data-field-type": "SingleLineText",
                    },
                    domProps: { value: _vm.formattedDate },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.formattedDate = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "req floating",
                      attrs: { for: "birthDate" },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.tc("profile.formFields.birthDate")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "field-validation-valid",
                    attrs: {
                      "data-valmsg-for": "birthDate",
                      "data-valmsg-replace": "true",
                    },
                  }),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "profile-info" }, [
        _c("div", { staticClass: "profile-info-icon icon-info" }),
        _vm._v(" "),
        _c("div", { staticClass: "profile-info-section" }, [
          _c("div", { staticClass: "profile-info-section-title" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.tc("profile.dataUseInfo.title")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "profile-info-section-description" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.tc("profile.dataUseInfo.description.birthDate")) +
                "\n      "
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }